export default __webpack_public_path__ + "static/media/background.565841e6.jpg";